// removed by extract-text-webpack-plugin
module.exports = {"footnote":"footnote__1-Bja"};


//////////////////
// WEBPACK FOOTER
// ./components/footnote/style.scss
// module id = 5gwI
// module chunks = 13